import React from 'react';
import { withStyles } from '@material-ui/core/styles';

//Text field input
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Button from '@material-ui/core/Button';


const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 500,
  },
});

class CoordinateSelect extends React.Component {

  state = {
    fromLatitude:'',
    toLatitude:'',
    fromLongitude:'',
    toLongitude:''
  };



    //Latitude and Longitude Coordinates

  handleTextFieldChange = name => event => {
    this.setState({[name]: event.target.value});

    this.props.onChange(name, event.target.value);
  };

  reset(event) {

    this.setState({  
      fromLatitude:'',
      toLatitude:'',
      fromLongitude:'',
      toLongitude:''
  });

  this.props.onChange('','');  

  };

  render() {

    return (
      <div>

        <ValidatorForm
                ref="form"
                onSubmit={this.handleTextFieldChange}

            >                        
            <TextValidator
                  name="fromLatitude"
                  floatingLabelText="From Latitude"
                  value={this.state.fromLatitude}
                  validators={['required']}
                  onChange={this.handleTextFieldChange("fromLatitude")}
                  errorMessages={['this field is required']}
                  style={{width:135}}
                  /> :
             <TextValidator
                  name="fromLongitude"
                  floatingLabelText="From Longitude"
                  value={this.state.fromLongitude}
                  validators={['required']}
                  onChange={this.handleTextFieldChange("fromLongitude")}
                  errorMessages={['this field is required']}
                  style={{width:135, marginLeft:10}}
             />    
            <TextValidator
                  name="toLatitude"
                  floatingLabelText="To Latitude"
                  value={this.state.toLatitude}
                  validators={['required']}
                  onChange={this.handleTextFieldChange("toLatitude")}
                  errorMessages={['this field is required']}
                  style={{width:135}}
                  />:    

             <TextValidator
                  name="toLongitude"
                  floatingLabelText="To Longitude"
                  value={this.state.toLongitude}
                  validators={['required']}
                  onChange={this.handleTextFieldChange("toLongitude")}
                  errorMessages={['this field is required']}
                  style={{width:135, marginLeft:10}}
                  />                                
        </ValidatorForm><br/>

      <Button size="large" color="primary" onClick={ this.reset.bind(this)} style={{marginLeft:100, marginTop:30}}>
        Reset
      </Button>
        {/* <button type="button" color="primary" onClick={ this.reset.bind(this) }>
              <span>Reset</span>
        </button> */}
      </div>
    );
  }
}



export default withStyles(styles)(CoordinateSelect);